import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import { KnowledgeDefaultSubText, KnowledgeDefaultText, PersonStyles, WorkStyles } from './styled';
import { KnowledgeCardsRowType } from './types';
var rowBox = xcss({
  marginInlineEnd: 'space.100',
  borderRadius: '3px',
  ':hover': {
    background: "var(--ds-surface-hovered, #F1F2F4)",
    cursor: 'pointer'
  }
});
export var KnowledgeCardsRow = function KnowledgeCardsRow(_ref) {
  var primaryText = _ref.primaryText,
    secondaryText = _ref.secondaryText,
    pictureUrl = _ref.pictureUrl,
    type = _ref.type,
    triggerProps = _ref.triggerProps,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Box, _extends({
    xcss: rowBox,
    paddingInline: "space.200",
    paddingBlock: "space.075"
  }, triggerProps, {
    onClick: onClick
  }), /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    alignBlock: "center"
  }, type === KnowledgeCardsRowType.PERSON ? /*#__PURE__*/React.createElement(PersonStyles, {
    src: pictureUrl
  }) : /*#__PURE__*/React.createElement(WorkStyles, {
    src: pictureUrl
  }), /*#__PURE__*/React.createElement(Stack, {
    spread: "space-between"
  }, /*#__PURE__*/React.createElement(KnowledgeDefaultText, null, primaryText), /*#__PURE__*/React.createElement(KnowledgeDefaultSubText, null, secondaryText))));
};